import React from "react"
import {
  DesktopPageHeights,
  PageRoutesMap,
  PageSections,
} from "../../../../../../../types/routes"
import SubListItem from "./components/SubListItem"

type Props = {
  isLast: boolean
  isOpen: boolean
  section: PageSections
}

const SubList = ({ isLast, isOpen, section }: Props) => (
  <div
    className={`absolute top-14 ${isOpen ? "" : "invisible"} ${
      isLast ? "right-2" : ""
    }`}
    style={{ backdropFilter: "blur(15px)", WebkitBackdropFilter: "blur(15px)" }}
  >
    <ul
      className={`flex flex-col list-none rounded bg-igem-light-blue bg-opacity-80 shadow-xl transition-all duration-300 ${
        isOpen ? `${DesktopPageHeights[section]}` : "h-0"
      } `}
    >
      {PageRoutesMap[section].map((s, i, arr) => (
        <SubListItem
          isFirst={i === 0}
          isLast={i === arr.length - 1}
          isOpen={isOpen}
          key={s.route}
          subItem={s}
        />
      ))}
    </ul>
  </div>
)

export default SubList
